import { render, staticRenderFns } from "./WillComponent.vue?vue&type=template&id=5667e2fc&scoped=true&"
import script from "./WillComponent.vue?vue&type=script&lang=js&"
export * from "./WillComponent.vue?vue&type=script&lang=js&"
import style0 from "./WillComponent.vue?vue&type=style&index=0&id=5667e2fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5667e2fc",
  null
  
)

export default component.exports